import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const bullseye: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M7.406-6.406Q8-5.826 8-5q-.002.831-.594 1.422A1.91 1.91 0 0 1 6-3a1.96 1.96 0 0 1-1.422-.578A1.96 1.96 0 0 1 4-5q-.001-.826.578-1.406A1.94 1.94 0 0 1 6-7q.826.002 1.406.594m.719 3.531A2.93 2.93 0 0 0 9-5q-.001-1.247-.875-2.125A2.9 2.9 0 0 0 6-8a2.93 2.93 0 0 0-2.125.875A2.9 2.9 0 0 0 3-5q-.001 1.235.875 2.125Q4.765-1.998 6-2q1.248.002 2.125-.875m.703-4.953A3.86 3.86 0 0 1 10-5q0 1.658-1.172 2.828A3.86 3.86 0 0 1 6-1Q4.343-1 3.172-2.172 2-3.342 2-5q0-1.655 1.172-2.828T6-9q1.655 0 2.828 1.172m1.766 4.766A4.8 4.8 0 0 0 11-5q-.001-1.013-.406-1.937A4.8 4.8 0 0 0 9.53-8.531a4.8 4.8 0 0 0-1.593-1.063A4.8 4.8 0 0 0 6-10a4.8 4.8 0 0 0-1.937.406 4.975 4.975 0 0 0-1.594 8.125q.667.675 1.594 1.078Q4.98.001 6 0q1.013 0 1.938-.39a4.975 4.975 0 0 0 2.656-2.672m.594-4.954Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.002 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};
